import { EntityIcon } from '..';
import { TProps } from '../types/TProps';

const roundSmSizeClassName = 'h-8 w-8 bg-[var(--color-avatar-bg)] text-xs leading-none text-[var(--color-on-surface)]';

export const EntityIconRoundSm = ({ className, sizeClassName, ...props }: TProps) => (
  <EntityIcon {...props} shape="round" sizeClassName={sizeClassName ?? roundSmSizeClassName} className={className} />
);
